import type { NoteValidityStatus } from "fin-web-components";
import { userStockNoteMocks } from "../user_holdings/UserStockNoteMock";
import type {
  MyNotesListParam,
  MyNotesListResult,
  MyNotesStatsParam,
  MyNotesStatsResult,
  MyNotesValidityFilter,
} from "./MyNotesType";

function matchValidity(
  status: NoteValidityStatus | null | undefined,
  filter: MyNotesValidityFilter
): boolean {
  if (filter === "all") {
    return true;
  }
  if (filter === "valid") {
    return status === "valid";
  }
  if (filter === "invalid") {
    return status === "invalid";
  }
  return status !== "valid" && status !== "invalid";
}

function buildStats(stockCode?: string): MyNotesStatsResult {
  const data = userStockNoteMocks.listNotes(stockCode);
  const notes = data.notes ?? [];
  const validCount = notes.filter((n) => n.validityStatus === "valid").length;
  const invalidCount = notes.filter((n) => n.validityStatus === "invalid").length;
  const markedCount = validCount + invalidCount;
  return {
    totalCount: notes.length,
    markedCount,
    validCount,
    invalidCount,
    validRate: markedCount > 0 ? validCount / markedCount : null,
  };
}

export const myNotesMocks = {
  listNotes(param: MyNotesListParam): MyNotesListResult {
    const pageNum = param.pageNum && param.pageNum > 0 ? param.pageNum : 1;
    const pageSize = param.pageSize && param.pageSize > 0 ? param.pageSize : 10;
    const filter = param.validityFilter ?? "all";
    const data = userStockNoteMocks.listNotes(param.stockCode);
    const filtered = (data.notes ?? [])
      .filter((n) => matchValidity(n.validityStatus, filter))
      .sort((a, b) => String(b.eventTime ?? "").localeCompare(String(a.eventTime ?? "")));
    const start = (pageNum - 1) * pageSize;
    const page = filtered.slice(start, start + pageSize);
    return {
      total: filtered.length,
      notes: page.map((n) => ({
        id: String(n.id ?? ""),
        stockCode: String(n.stockCode ?? "").toUpperCase(),
        stockName: String(n.stockName ?? ""),
        eventTime: String(n.eventTime ?? ""),
        content: String(n.content ?? ""),
        category: (n.category ?? "基本面") as MyNotesListResult["notes"][number]["category"],
        validityStatus: n.validityStatus ?? null,
      })),
    };
  },

  queryNoteStats(param: MyNotesStatsParam): MyNotesStatsResult {
    return buildStats(param.stockCode);
  },
};
